import { useEffect } from "react";

import { useRootStore } from "store";
import AlertWithAction from "./AlertWithAction";

import "./Notifications.scss";

type Props = {
  fetchNotifications: () => void;
  setNotificationRead: (id: string) => void;
};

export default function Notifications({
  fetchNotifications,
  setNotificationRead
}: Props) {
  const { messages } = useRootStore((state) => state.notifications);

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReadTriggered = (id: string) => {
    setNotificationRead(id);
  };

  return (
    <>
      {messages && messages.length === 0 ? (
        <></>
      ) : (
        <div className="notifications">
          {messages.map((message) => {
            return (
              <AlertWithAction
                key={message.id}
                message={message}
                onReadTriggered={() => handleReadTriggered(message.id)}
              />
            );
          })}
        </div>
      )}
    </>
  );
}
